var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRestoreArrow = function SvgIconRestoreArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.82 4.5q-3.165.078-5.312 2.188Q5.398 8.798 5.32 12h-2.5l3.243 3.242.078.117L9.5 12H7q.078-2.5 1.719-4.14 1.64-1.641 4.101-1.68 2.5.039 4.14 1.68Q18.603 9.5 18.68 12q-.078 2.5-1.72 4.14-1.64 1.641-4.14 1.68a5.95 5.95 0 0 1-2.265-.43 5.7 5.7 0 0 1-1.836-1.288l-1.172 1.21a7.7 7.7 0 0 0 2.344 1.602q1.367.585 2.93.586 3.203-.078 5.312-2.187T20.32 12q-.077-3.203-2.187-5.312T12.82 4.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRestoreArrow);
export { ForwardRef as ReactComponent };